<template lang="html">
    <div id="error" class="d-flex flex-fill flex-wrap justify-content-center align-items-center align-content-center">
        <div class="blurCover"></div>
        <div class="blurBack"></div>
        <div class="glassBack">
            <div class="position-relative w-100 h-100 d-flex justify-content-center align-items-center align-content-center">
                <img :src="a9" alt="">
                <div class="line1"></div>
                <div class="line2"></div>
            </div>
            
        </div>
        <div class="w-100 txtErr d-flex justify-content-center align-items-center align-content-center">4<span class="imgContent"><img :src="a8" class="imgErr">0</span>4</div>
        <div class="errorLabel w-100 text-1 text-center font-1 color-1 fw-bold my-4">
            Ooops!
        </div>
        <div class="w-100 text-6 text-center font-3 fw-bold">
            Página no encontrada
        </div>
    </div>
</template>
<script>

export default {
    name: "NotFound",
    data() {
        return {
            a8: require("@/assets/images/a8.png"),
            a9: require("@/assets/images/a9.png"),
        };
    },
};
</script>
<style lang="css">
    .blurCover {
        position: fixed;
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
        z-index: 20;
        backdrop-filter: blur(8px);
        animation: secuence1 5s linear 1 forwards;
        pointer-events: none;
    }
    .glassBack {
        position: fixed;
        width: 200vw;
        height: 200vh;
        left: -50vw;
        top: -50vh;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        z-index: 21;
        opacity: 1;
        animation: secuence2 5s linear 1 forwards;
        pointer-events: none;
    }
    .glassBack img {
        object-fit: inherit;
        margin-left: 0.6%;
        margin-top: 0.5%;
        width: 51%;
    }
    .line1 {
        position: absolute;
        height: 1.3vw;
        left: 21.25%;
        margin-top: 10%;
        width: 30vw;
        border-radius: 10px;
        background-color: #000;
        transform: rotate(-53deg);
    }
    .line2 {
        position: absolute;
        height: 1.3vw;
        right: 20.6%;
        margin-top: 10%;
        border-radius: 10px;
        width: 30vw;
        background-color: #000;
        transform: rotate(53deg);
    }
    .blurBack {
        animation: secuence3 5s linear 1 forwards;
        z-index: 20;
        position: fixed;
        width: 200vw;
        height: 200vh;
        margin-left: -50vw;
        margin-top: -50vh;
        inset: 0;
        opacity: 0;
        -webkit-mask: url("data:image/svg+xml;base64,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")
            0/50% 100%,
            linear-gradient(#fff, #fff);
        mask: url("data:image/svg+xml;base64,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")
            0/50% 100%,
            linear-gradient(#fff, #fff);
        mask-composite: exclude;
        -webkit-mask-position: center;
        -webkit-mask-repeat: no-repeat;
        mask-position: center;
        mask-repeat: no-repeat;
        background-color: rgba(255, 255, 255, 0);
        backdrop-filter: blur(8px);
        pointer-events: none;
    }

    #error {
        width: 100%;
        min-height: calc(100vh - 300px);
    }
    .imgContent {
        color: transparent;
        position: relative;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
    }
    .imgErr {
        height: 240px;
        width: 240px;
        position: absolute;
        opacity: 0;
        animation: errorAppend 0.5s linear 0.5s 1 forwards;
    }
    .txtErr {
        font-size: 260px;
        height: 300px;
        line-height: 0;
    }
    .errorLabel {
        animation: error 10s infinite linear;
    }
    @keyframes error {
        0% {
            transform: translateY(0px);
        }
        25% {
            transform: translateY(-10px);
        }
        50% {
            transform: translateY(0px);
        }
        75% {
            transform: translateY(10px);
        }
        100% {
            transform: translateY(0px);
        }
    }
    @keyframes errorAppend {
        0% {
            opacity: 0;
            transform: scale(10);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
        }

        @keyframes secuence1 {
        0% {
            opacity: 1;
        }
        9% {
            opacity: 1;
        }
        10% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes secuence3 {
        0% {
            opacity: 0;
        }
        9% {
            opacity: 0;
        }
        10% {
            opacity: 1;
            transform: scale(1) translate(0, 0);
        }
        20% {
            transform: translate(-15vw, -10vh);
        }
        30% {
            transform: translate(12vw, -20vh);
        }
        40% {
            transform: translate(5vw, 6vh);
        }
        50% {
            transform: translate(-10vw, 6vh);
        }
        60% {
            opacity: 1;
            transform: scale(1) translate(20vw, -5vh);
        }
        70% {
            opacity: 1;
            transform: scale(1) translate(20vw, -5vh);
        }
        80% {
            transform: scale(10) translate(0, 0);
        }
        90% {
            opacity: 0;
            backdrop-filter: blur(8px);
            transform: scale(10) translate(0, 0);
        }
        100% {
            transform: scale(1) translate(0, 0);
            opacity: 0;
            backdrop-filter: blur(0);
        }
    }
    @keyframes secuence2 {
        0% {
            transform: scale(0);
            opacity: 1;
        }
        10% {
            transform: scale(1) translate(0, 0);
        }
        20% {
            transform: translate(-15vw, -10vh);
        }
        30% {
            transform: translate(12vw, -20vh);
        }
        40% {
            transform: translate(5vw, 6vh);
        }
        50% {
            transform: translate(-10vw, 6vh);
        }
        60% {
            opacity: 1;
            transform: scale(1) translate(20vw, -5vh);
        }
        70% {
            opacity: 1;
            transform: scale(1) translate(20vw, -5vh);
        }
        80% {
            opacity: 0;
            transform: scale(10) translate(0, 0);
        }
        100% {
            transform: scale(10) translate(0, 0);
            opacity: 0;
        }
    }
</style>